import axiosIns from '@/plugins/axios'

export default {
  getTimecardStatuses() {
    return axiosIns.get('/waiter/timecard_statuses')
  },
}
